<template>
  <AddonCard
    icon="users"
    title="User seats"
    :data-change="changeIndex"
    subtitle="Scale your organization with extra user seats."
    :data-has-user-plans="hasUserPlans ? '1' : '0'"
    addon-id="user"
    :loading="loading"
    :data-has-button="hasSubscriptionAndNoAddon ? '1' : '0'"
    :data-bad-currency-or-schedule="!product ? '1' : '0'"
    :no-footer="!hasSubscriptionAndNoAddon && !product"
  >
    <AddonTable v-if="product" :headers="['Usage', 'Cost']">
      <Tr :key="`${product.perUnitCost}`">
        <Td>Extra seats</Td>
        <Td>
          <TablePrice
            v-if="product.perUnitCost"
            :symbol="selectedCurrencySymbol || ''"
            :currency="selectedCurrency"
            :price="product.perUnitCost"
            :text="'per user per month'"
          />
        </Td>
      </Tr>
    </AddonTable>
    <AddonNotSupported v-else />
    <template #footer>
      <FormInput
        class="w-24"
        v-if="product"
        v-model="selectedUserPlanQuantity"
        type="number"
        min="0"
        step="10"
        size="xs"
        :full="false"
      />
      <UpgradeButtonAddUserPlan
        v-if="hasSubscriptionAndNoAddon"
        size="sm"
        :expedite="!!selectedUserPlanQuantity"
      />
    </template>
  </AddonCard>
</template>
<script setup lang="ts">
import type { StripeUserPlanProduct } from '@mailslurp/admin-sdk';

import { computed, onMounted, ref } from 'vue';

import { useStore3 } from '../../../store/main';
import { storeToRefs } from 'pinia';
import Tr from '../../../components/table/parts/Tr.vue';
import Td from '../../../components/table/parts/Td.vue';
import AddonCard from '../AddonCard.vue';
import TablePrice from '../../pricing/TablePrice.vue';
import FormInput from '../../form/FormInput.vue';
import UpgradeButtonAddUserPlan from '../../pricing/addon/UpgradeButtonAddUserPlan.vue';
import { loadFetchMany } from '../../../lib/services/helpers';
import AddonNotSupported from '../AddonNotSupported.vue';
import AddonTable from '../AddonTable.vue';

const store3 = useStore3();

const loading = ref<boolean>(false);

defineProps<{
  changeIndex: number;
}>();

const {
  productUserPlans,
  selectedSchedule,
  selectedCurrency,
  selectedCurrencySymbol,
  subscription,
  userPlans,
  selectedUserPlanQuantity,
} = storeToRefs(store3);
const product = computed(() => {
  return (productUserPlans.value?.products ?? []).filter(
    (it: StripeUserPlanProduct) =>
      it.schedule?.toString() === selectedSchedule.value?.toString() &&
      it.currency?.toString() === selectedCurrency.value?.toString(),
  )?.[0];
});
const hasUserPlans = computed(() => {
  return (userPlans.value?.length ?? 0) > 0;
});
const hasSubscriptionAndNoAddon = computed(() => {
  return subscription.value && !hasUserPlans.value;
});

onMounted(async () => {
  await loadFetchMany(
    [() => store3.getProductUserPlans(), () => store3.getUserPlans()],
    store3,
    loading,
  );
});
</script>
